import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=c510b5a2&scoped=true&"
import script from "./MessagePanel.vue?vue&type=script&lang=js&"
export * from "./MessagePanel.vue?vue&type=script&lang=js&"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=c510b5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c510b5a2",
  null
  
)

export default component.exports